import axios from "@axios" //eslint-disable-line

function getNonPaginatedData(route, params, callback) {
    let request = new Promise(() => null, () => null)
    if (!Object.keys(params).length) {
        request = axios.get(route).then(callback);
    }
    return request
}

const abortControllers = {};

export default {
    /*
     * main insights API
     */
    getTargetingSets(country, category) {
        return axios.get('/reporting/bids/', {
            params: {
                country_uuids: [ country ],
                category_uuid: category,
            },
        })
    },
    retrieveTargetingSetsByCountries(countryUuids, categoryUuid) {
        return axios.post('/reporting/bids/bulk', {
            country_uuids: countryUuids,
            category_uuid: categoryUuid,
        })
    },
    exportProductSignalsReport(productUuid, period) {
        return axios.get(`/products/${productUuid}/signals/export`, {
            params: {
                period,
            },
            responseType: 'blob',
        })
    },
    getBillableStatuses(params = {}) {
        return getNonPaginatedData('/reporting/clicks/statuses', params, resp => ({
            data: {
                data: resp.data.data,
                meta: {
                    cursor: {
                        next: null,
                    },
                },
            },
        }))
    },
    getClicks(params) {
        if (abortControllers.getClicks) {
            abortControllers.getClicks.abort()
        }
        abortControllers.getClicks = new AbortController()

        return axios.get('/reporting/clicks', {
            params,
            signal: abortControllers.getClicks.signal,
        })
    },
    getGeoLocationsFilter(params = {}) {
        return getNonPaginatedData('/countries', params, resp => ({
            data: {
                data: resp.data.data,
                meta: {
                    cursor: {
                        next: null,
                    },
                },
            },
        }))
    },
    getGeoPresetsFilter(params = {}) {
        return getNonPaginatedData('/locations', params, resp => ({
            data: {
                data: resp.data.data.presets,
                meta: {
                    cursor: {
                        next: null,
                    },
                },
            },
        }))
    },
    getIndustries(params) {
        return axios.get('report/industries', { params })
    },
    getIvtMetrics(params) {
        return axios.get('reporting/ivt', { params })
    },
    getIvtMetricFilters() {
        return axios.get('reporting/ivt/filters')
    },
    getProductSignals(programUuid, period = 30, params = {}) {
        return axios.get('signals', {
            params: {
                program_uuid: programUuid,
                period,
                ...params,
            },
        })
    },
    getFilters(clientUuid) {
        return axios.get(`reporting/clicks/${clientUuid}/filter`)
            .then(resp => resp.data)
    },
    getTopCompanies(period = 30, params = {}) {
        return axios.post('report/companies-report/retrieve', {
            params: {
                period,
                ...params,
            },
        })
    },
}
